/* eslint-disable no-loop-func */
import { useEffect, useRef, useState } from "react";
import ReactDOMServer from "react-dom/server";

import { createMap } from "utils/googleMap/createMap";
import MapMarker from "utils/googleMap/MapMarker";

import "./BranchesInfoMap.scss";

export type BranchesInfoMapProps = {
  position?: { lat: number; lng: number };
  customCenter?: { lat: number; lng: number };
  content?: JSX.Element;
  branchData?: {
    coords: { lat: number; lng: number };
    content: JSX.Element;
    address?: string;
  }[];
  activeBranchIndex?: number;
  changeBranch?: Function;
};

export function BranchesInfoMap({
  branchData,
  customCenter,
  activeBranchIndex,
  changeBranch,
}: BranchesInfoMapProps) {
  const ref = useRef<HTMLDivElement>(null);
  const [map, setMap] = useState<google.maps.Map>();
  const [activeMarkerIndex, setActiveMarkerIndex] = useState<number>();

  useEffect(() => {
    activeBranchIndex
      ? setActiveMarkerIndex(activeBranchIndex)
      : activeBranchIndex === 0
      ? setActiveMarkerIndex(0)
      : setActiveMarkerIndex(undefined);
  }, [activeBranchIndex]);
  useEffect(() => {
    if (customCenter) {
      map?.setCenter(customCenter);
    }
  }, [customCenter, map]);

  useEffect(() => {
    createMap({
      map,
      setMap,
      element: ref.current,
      mapOptions: {
        center: { lat: 41.7151, lng: 44.8271 },
        zoom: 10,
      },
    });
  }, [ref, branchData, map]);

  return (
    <div className="branches-info-map-container" ref={ref}>
      {branchData?.map((branch, i) => {
        const branchCoords = branch?.coords;
        return (
          <MapMarker
            key={i}
            position={branchCoords}
            content={ReactDOMServer.renderToString(branch?.content)}
            map={map}
            active={activeMarkerIndex === i}
            currentIndex={i}
            setActiveIndex={(index) => {
              if (activeMarkerIndex === i) {
                setActiveMarkerIndex(undefined);
              } else {
                setActiveMarkerIndex(index);
              }

              if (changeBranch) {
                changeBranch(branch.address);
              }
            }}
          />
        );
      })}
    </div>
  );
}
